import { getApiGalaxyServer } from 'services';
import { AxiosResponse } from 'axios';
import ApiClientManager from 'core/apiClient';

export interface FetchReplicaCredentialsParams {
  targetServiceId: number;
  tenant?: string;
  realmId?: string;
}

export interface FetchReplicaCredentialsResponse {
  exists: boolean;
}

/**
 * Fetches replica database credentials metadata for a given team and service.
 * Returns whether credentials exist for the specified team and service.
 */
export const fetchReplicaCredentialsApi = ({
  params: { targetServiceId, tenant, realmId },
  token,
  config,
}: BaseApiParams<FetchReplicaCredentialsParams>): Promise<
  AxiosResponse<FetchReplicaCredentialsResponse>
> => {
  const customHeaders =
    tenant && realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: tenant, realmId })
      : undefined;

  return getApiGalaxyServer(
    `/azure/replicaCredentials/${targetServiceId}`,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
